import Box from '@mui/material/Box';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TRANSFER } from '../../models/transfer';
import { BookingSummary } from '../BookingSummary';
import { WithSidebar } from '../WithSidebar';
import { ChildSeats } from './ChildSeats';
import { Comment } from './Comment';
import { DifferentPassenger } from './DifferentPassenger';
import { Luggage } from './Luggage';
import { LuggageSelection } from './LuggageSelection';
import { NextButton } from './NextButton';
import { Services } from './Services';
import { Typography } from '@mui/material';
import { PageTitle } from '../../../common/components/PageTitle';

const BookingDetailsForm = ({
    data: { booking, firstTransfer, secondTransfer },
    update: { updateBooking, updateFirstTransfer },
    url,
    touch: { touchBooking },
    errorsSrc: { bookingErrorSrc },
    validationErrors,
    showValidationErrors,
}) => {
    const { t } = useTranslation();

    const bookingError = bookingErrorSrc.bind(null, validationErrors);
    const isSpecialTransfer = firstTransfer.typeId === TRANSFER.SPECIAL;

    const content = (
        <>
            <LuggageSelection
                transfer={firstTransfer}
                updateTransfer={updateFirstTransfer}
                bookingError={bookingError}
                sx={{ mb: 3 }}
            />

            <Typography variant="h4" sx={{ mb: 3 }}>
                {t('extras-title')}
            </Typography>

            {!isSpecialTransfer && (
                <Services
                    transfer={firstTransfer}
                    secondTransfer={secondTransfer}
                    updateTransfer={updateFirstTransfer}
                />
            )}
            <Luggage transfer={firstTransfer} updateTransfer={updateFirstTransfer} />
            {!isSpecialTransfer && <ChildSeats transfer={firstTransfer} updateTransfer={updateFirstTransfer} />}
            <DifferentPassenger
                booking={booking}
                onChange={updateBooking}
                bookingError={bookingError}
                touchBooking={touchBooking}
            />
            <Comment booking={booking} onChange={updateBooking} />
            <NextButton
                url={url}
                sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'right' }}
                validationErrors={validationErrors}
                showValidationErrors={showValidationErrors}
            />
        </>
    );

    const sidebar = (
        <>
            <BookingSummary
                sx={{ maxWidth: { xs: 350 } }}
                firstTransfer={firstTransfer}
                secondTransfer={secondTransfer}
                url={url}
            />
            <NextButton
                url={url}
                sx={{ display: { xs: 'flex', md: 'none' } }}
                validationErrors={validationErrors}
                showValidationErrors={showValidationErrors}
            />
        </>
    );

    return (
        <>
            <PageTitle>{t('details-title')}</PageTitle>
            <Box sx={(theme) => theme.mixins.box(theme)}>
                <WithSidebar content={content} sidebar={sidebar} />
            </Box>
        </>
    );
};

export { BookingDetailsForm };
